import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {
  AuthConnectService,
  LOCAL_STORAGE_KEYS,
  PlatformService,
} from '@panamax/app-state';
import { PATHS } from '../shared/constants/paths';

@Component({
  selector: 'app-scheduled-maintenance',
  templateUrl: './scheduled-maintenance.page.html',
  styleUrls: ['./scheduled-maintenance.page.scss'],
})
export class ScheduledMaintenancePage {
  constructor(
    private router: Router,
    private authConnectService: AuthConnectService,
    readonly platformService: PlatformService,
  ) {}

  async returnToLogin() {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.params);
    await this.authConnectService.logout();
    this.router.navigate([PATHS.LOGIN]);
  }
}
